import { render, staticRenderFns } from "./CQrBtn.vue?vue&type=template&id=0053eff0&scoped=true"
import script from "./CQrBtn.vue?vue&type=script&lang=js"
export * from "./CQrBtn.vue?vue&type=script&lang=js"
import style0 from "./CQrBtn.vue?vue&type=style&index=0&id=0053eff0&scoped=true&lang=css"
import style1 from "./CQrBtn.vue?vue&type=style&index=1&id=0053eff0&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0053eff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0053eff0')) {
      api.createRecord('0053eff0', component.options)
    } else {
      api.reload('0053eff0', component.options)
    }
    module.hot.accept("./CQrBtn.vue?vue&type=template&id=0053eff0&scoped=true", function () {
      api.rerender('0053eff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CQrBtn.vue"
export default component.exports